import { ApiError } from '../../../api/client.ts';

/** Field paths of a 400 `validation_failed` (`issues[].path`, dotted) with their messages; the first message per path wins. */
export function problemFieldErrors(error: unknown): Record<string, string> {
  if (!(error instanceof ApiError) || !Array.isArray(error.problem.issues)) return {};
  const out: Record<string, string> = {};
  for (const issue of error.problem.issues as Array<{ path?: string; message?: string }>) {
    const path = issue.path ?? '';
    out[path] ??= issue.message ?? 'Invalid value.';
  }
  return out;
}

/** One line for a failed request: the problem's detail or title, else a generic text. */
export function problemText(error: unknown): string {
  if (!(error instanceof ApiError)) return 'Something went wrong.';
  if (error.status === 403) return `${error.message}. Ask an admin for the permission.`;
  return error.message;
}

/** The first sentence-cased message of a zod issue per field key (`map` turns an issue path into the form's key). */
export function contractIssues(issues: ReadonlyArray<{ path: ReadonlyArray<PropertyKey>; message: string }>, messages: Record<string, string>, map: (path: ReadonlyArray<PropertyKey>) => string = (p) => p.map(String).join('.')): Record<string, string> {
  const out: Record<string, string> = {};
  for (const issue of issues) {
    const key = map(issue.path);
    out[key] ??= messages[key] ?? sentence(issue.message);
  }
  return out;
}

const sentence = (text: string) => {
  const t = text.charAt(0).toUpperCase() + text.slice(1);
  return t.endsWith('.') ? t : `${t}.`;
};

/** «17 Oct 2026, 12:00 UTC»: times on settings pages are shown in UTC, like the API stores them. */
export function formatUtc(iso: string | null | undefined): string {
  if (!iso) return 'Never';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return `${d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' })}, ${d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', timeZone: 'UTC' })} UTC`;
}
